const BACK_IGNORED_WORKFLOW_STATE_TYPES: any = Object.freeze({
    ACTION: 'ACTION',
    RULE_DECISION: 'RULE_DECISION',
    APPLICANT_RULE_DECISION: 'APPLICANT_RULE_DECISION',
    BLOCKING: 'BLOCKING'
});
export default BACK_IGNORED_WORKFLOW_STATE_TYPES;